const WIDGET_API_KEY_TEST = "8a7046ec-e26f-1d15-adbf-472dc211e47b";
const WIDGET_API_KEY_PROD = "a1485fb5-69a5-71bc-217d-4be9b0891977";

export const resolveWidgetApiKey = () => {
    if (window.location.hostname.endsWith(".testkontur.ru")) {
        return WIDGET_API_KEY_TEST;
    }

    return WIDGET_API_KEY_PROD;
};
